import { ca } from '@cian/analytics';

export function trackParkTabClick(label: string) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Card_JK',
    action: 'click_park',
    label,
    useLastProducts: true,
  });
}
